'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transform = {};

exports.__exports = transform;
